import React from 'react';
import { createIntl, createIntlCache, FormattedNumber } from 'react-intl';
import PageLink from 'components/PageLink/PageLink';
import { getTemplateString } from 'common/helpers/string';
import { getTemplateToken } from 'common/helpers/tokensFormatter';
import styles from './PersonalisedPaymentPlan.module.scss';
import classnames from 'classnames';

interface Props {
  PageData?: any;
  Model?: any;
}

// TODO: Check is it proper way
const cache = createIntlCache();

// TODO: Get current language
const intl = createIntl(
  {
    locale: 'fr',
  },
  cache,
);

const PersonalisedPaymentPlan = ({ PageData, Model }: Props) => {
  // TODO: Check it on acc with PPP
  const proposedPaymentPlanTermToken = getTemplateToken(
    Model?.ProposedPaymentPlanTerm ?? 0,
  );
  const finalInstallmentAmountToken = getTemplateToken(    
    Model?.FormattedCurrencyProposedPaymentPlanFinalInstallment
  );
  const getChooseThisPlanButtonClass = () =>{
    const personalisedPaymentPlanClass = "PersonalisedPaymentPlan__link Button";
    const personalisedPaymentPlanWhiteLinkClass =   "PersonalisedPaymentPlan__whitelink";  
   return  Model?.ShowProposedPlanButtonWhite ? personalisedPaymentPlanClass : `${personalisedPaymentPlanClass} ${personalisedPaymentPlanWhiteLinkClass}`;
  }
  const paymentPlanTtitle = getTemplateString(
    PageData?.ProposedPaymentPlanTitle,
  );
  const finalPaymentLabel = getTemplateString(
    PageData?.ProposedPaymentPlanFinalPaymentLabel,
  );
  return (
    <div className={styles.PersonalisedPaymentPlan}>
      <div data-type="Promotion" data-creative-slot="Portal-Home-Top" data-promotion-name="Plan-Suggestion" >
      {!Model?.HidePayerReviewProposedPlanTerm &&
      (<div
        className={styles.header}
        dangerouslySetInnerHTML={{
          __html:
            (paymentPlanTtitle &&
              paymentPlanTtitle({
                ProposedPlanTerm: proposedPaymentPlanTermToken,
              })) ||
            '',
        }}
      />)}
      <div className={styles.content}>
        <h3 className={styles.heading}>
          {PageData?.PersonalisedPaymentPlanHeading}
        </h3>
        <div className={classnames(styles.offer,Model?.HidePayerReviewProposedPlanTerm && styles.offerCenter)}>
          <div className={styles.label}>
            {PageData?.YouPayLabel}
            <div className={styles.value}>
              {Model?.ProposedPaymentPlanInstallmentAmount && (                
                Model?.FormattedCurrencyProposedPaymentPlanInstallment
              )}
              
            </div>
          </div>
          {!Model?.HidePayerReviewProposedPlanTerm &&
          (<>
          <i className={styles.icon}></i>
          
          <div className={styles.label}>
            {PageData?.ForLabel}
            <div className={styles.value}>{Model?.ProposedPaymentPlanTerm} {PageData?.MonthsLabel}</div>
          </div>
          </>)
          }
        </div>
        {!Model?.HidePayerReviewProposedPlanTerm &&
        (<div
          className={styles.notice}
          dangerouslySetInnerHTML={{
            __html: finalPaymentLabel
              ? finalPaymentLabel({
                  ProposedPlanTerm: proposedPaymentPlanTermToken,
                  ProposedPlanFinalInstallmentAmount:
                    finalInstallmentAmountToken,
                })
              : '',
          }}
        />)}
        
         <PageLink
          url={Model?.ChooseProposedPlanUrl}
          text={PageData?.ChooseThisPlanButtonLabel}
          className={getChooseThisPlanButtonClass()}
          disabled={false}
        />       
      </div>
      </div>
    </div>
  );
};

export default PersonalisedPaymentPlan;
